// extracted by mini-css-extract-plugin
module.exports = {"root":"Sorting_root__2Y86-","top":"Sorting_top__13gNc","first":"Sorting_first__h4YzY","down":"Sorting_down__3o3pL","second":"Sorting_second__3Qtvz"};